import { ModuleLayout, type ModuleTab } from './ModuleLayout.js';
import { useVisibleTabs } from '../useNavAccess.js';
import { useTenantSettings } from '../../lib/tenantSettings.js';
import { purchaseRequestsVisible } from '../../lib/types/tenantSettings.js';

export const PROCUREMENT_TABS: readonly ModuleTab[] = [
  { id: 'overview', hrefSuffix: '', label: 'نمای کلی' },
  { id: 'requests', hrefSuffix: '/requests', label: 'درخواست‌های خرید' },
  { id: 'orders', hrefSuffix: '/orders', label: 'سفارش‌های خرید' },
  { id: 'suppliers', hrefSuffix: '/suppliers', label: 'تأمین‌کنندگان' },
  { id: 'assistant', hrefSuffix: '/assistant', label: 'دستیار' },
];

export function ProcurementModuleLayout() {
  const settings = useTenantSettings();
  const permittedTabs = useVisibleTabs('procurement', PROCUREMENT_TABS);
  const tabs = purchaseRequestsVisible(settings)
    ? permittedTabs
    : permittedTabs.filter((tab) => tab.id !== 'requests');
  return (
    <ModuleLayout
      // Title matches navConfig.ts's sidebar label ("خرید و تأمین") —
      // HubPage.tsx previously said "تدارکات" here, a second, inconsistent
      // name for the same module.
      moduleId="procurement"
      title="خرید و تأمین"
      tabs={tabs}
      cta={{ label: 'سفارش خرید', icon: 'plus', hrefSuffix: '/orders', tabIds: ['overview'] }}
    />
  );
}
